import { yupResolver } from "@hookform/resolvers/yup";
import { Switch } from "antd";
import FormHubSelect from "components/Common/Form/FormHubSelect";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import { Button, Col, Form, FormGroup, Label, Row } from "reactstrap";
import * as yup from "yup";
import MessageFormValidate from "../../../components/shared-components/MessageFormValidate";
import { formValidate } from "../../../helpers/form_helper";
import {
  useCreateLocation,
  useTransports,
  useUpdateLocation,
  useDistricts,
  useProvinces,
  useWards,
} from "../../../hooks";
import DistrictSelect from "./DistrictSelect";
import GroupCodeSelect from "./GroupCodeSelect";
import ProvinceSelect from "./ProvinceSelect";
import WardSelect from "./WardSelect";
import { CustomerLocationType } from "./utils";
import { getPhoneValidation } from "constants/validate";
import useCustomHook from "../useCustomHook";

const CustomerLocationForm = ({
  location,
  customerId,
  onSuccess,
  type,
  ...props
}) => {
  console.log("🚀 ~ file: CustomerLocationForm.js:25 ~ type:", type);
  const { t } = useTranslation(["order"]);

  const { addToast } = useToasts();
  const [is_level_2, setIsLevel2] = useState(true);

  const tCustomer = useTranslation(["customer"]).t;
  const isTypeReturn = () => {
    return type == CustomerLocationType.RETURN_RESULT;
  };

  const initDefaultValues = {
    is_default: location?.is_default ? 1 : 0,
    mapping_code: location?.mapping_code || "",
    group_code: location?.group_code || [],
    code: location?.code || "",
    address: location?.address || "",
    ward_code: location?.ward_code ? { value: location.ward_code } : undefined,
    district_code: location?.district_code
      ? { value: location.district_code }
      : undefined,
    province_code: location?.province_code
      ? { value: location.province_code }
      : undefined,
    transport_id: location?.transport
      ? { label: location.transport.name, value: location.transport.id }
      : undefined,
    customer_id: location?.customer_id || customerId,
    type: location?.type || null,
    location_type: type,
    note: location?.note || null,
    contact_phone: location?.contact_phone || "",
    contact_name: location?.contact_name || "",
    hub_id: undefined,
  };
  const onLocationSuccess = data => {
    onSuccess?.(data.data);
  };

  const onErrorCreateUpdateLocation = error => {
    if (error.code === 422 && error.fields.length > 0) {
      error.fields.forEach(item => {
        switch (item.field) {
          case "mapping_code":
            setError("mapping_code", {
              type: "manual",
              message: item.message,
            });
            break;
          default:
            addToast(item.message, {
              appearance: "error",
              autoDismiss: true,
              autoDismissTimeout: 10000,
            });
            break;
        }
      });
    }
  };

  const { mutate: onCreateLocation, isLoading: isLoadingCreateLocation } =
    useCreateLocation(onLocationSuccess, onErrorCreateUpdateLocation);

  const { mutate: onUpdateLocation, isLoading: isLoadingUpdateLocation } =
    useUpdateLocation(onLocationSuccess, onErrorCreateUpdateLocation);

  const validator = {
    contact_name: yup
      .string()
      .required(
        t("form.validate.required", { title: t("form.receiver_contact_name") })
      ),
    contact_phone: yup
      .string()
      .nullable()
      .required(
        t("form.validate.required", { title: t("form.receiver_contact_phone") })
      )
      .matches(getPhoneValidation(t).regex, getPhoneValidation(t).errorMessage)
      .when(getPhoneValidation(t).when),
    address: yup
      .string()
      .required(
        t("form.validate.required", { title: t("form.receiver_address") })
      ),
    ward_code: yup.object().when([], {
      is: () => is_level_2,
      then: yup.object().nullable(),
      otherwise: yup
        .object()
        .nullable()
        .required(
          t("form.validate.select", { title: t("form.receiver_ward_code") })
        ),
    }),
    district_code: yup
      .object()
      .nullable()
      .required(
        t("form.validate.select", {
          title: is_level_2 ? "Phường xã" : t("form.receiver_district_code"),
        })
      ),
    province_code: yup
      .object()
      .nullable()
      .required(
        t("form.validate.select", { title: t("form.receiver_province_code") })
      )
      .nullable(),
  };
  if (isTypeReturn()) {
    validator.group_code = yup.array();
    validator.is_default = yup.bool();
    validator.mapping_code = yup.string();
    validator.code = yup.string();
    validator.transport_id = yup
      .object()
      .nullable()
      .required(
        t("form.validate.select", { title: tCustomer("form.transport") })
      )
      .nullable();
    validator.hub_id = yup
      .object()
      .nullable()
      .required(t("form.validate.select", { title: tCustomer("form.hub") }));
  }
  const addressValidationSchema = yup.object().shape(validator);

  const mainForm = useForm({
    resolver: yupResolver(addressValidationSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    formState: { errors, touchedFields, isSubmitting, isDirty },
    control,
    setValue,
    getValues,
    register,
    trigger,
    watch,
    setError,
  } = mainForm;

  const hubWatch = watch("hub_id");
  const transportWatch = watch("transport_id");

  const handleSubmitForm = () => {
    trigger();
    handleSubmit(() => {
      const data = getValues();
      data.is_default = data.is_default ? 1 : 0;
      data.group_code =
        type !== CustomerLocationType.RECEIVE
          ? data.group_code.map(item => item.value)
          : undefined;
      data.district_code = data.district_code?.value;
      data.province_code = data.province_code?.value;
      // data.ward_code = data.ward_code?.value;
      data.ward_code = is_level_2 ? null : data.ward_code?.value;
      data.transport_id = data.transport_id?.value;
      data.hub_id = data.hub_id?.value;
      if (location) {
        onUpdateLocation({ id: location.id, data: data });
      } else {
        onCreateLocation(data);
      }
    })();
  };

  const [transportParams, setTransportParams] = useState({
    run: false,
    params: {
      record_status: "O",
      page: -1,
    },
  });

  const isDisableTransport = useMemo(() => {
    if (hubWatch || transportWatch) return false;

    return true;
  }, [hubWatch, transportWatch]);

  const onChangeHub = hub => {
    setValue("hub_id", hub);
    setValue("transport_id", null);
    setTransportParams(prev => ({
      ...prev,
      run: true,
      params: {
        ...prev.params,
        "filter[hub_id]": hub.value,
      },
    }));
  };

  const { data: transports, refetch: refetchTransports } = useTransports({
    params: transportParams.params,
  });

  const optionTransport = useMemo(() => {
    if (transports && transports.items && transports.items.length > 0) {
      return transports.items.map(e => {
        return {
          label: e.name,
          value: e.id,
        };
      });
    }

    return [];
  }, [transports]);

  const initLocalitiesParams = () => {
    return {
      countryId: 1,
      type: 1,
      parent_code: "",
    };
  };

  useEffect(() => {
    if (location) {
      if (location.is_new_address === "N") {
        setIsLevel2(true);
      } else if (
        location.from_hub_is_new_address === "N" ||
        location.to_hub_is_new_address === "N"
      ) {
        setIsLevel2(true);
      } else if (!location.district_code) {
        setIsLevel2(true);
      } else if (location.is_level_2 !== true) {
        setIsLevel2(false);
      } else {
        setIsLevel2(true);
      }
    } else {
      setIsLevel2(true);
    }
  }, [location]);

  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);

  const handleChangeIsLevel2 = value => {
    setIsLevel2(value);
    setValue("province_code", null);
    setValue("district_code", null);
    setValue("ward_code", null);
    setValue("hub_id", null);
  };

  const { data: receiver_province_code, refetch: refetchProvinces } =
    useProvinces({
      ...provinceParams,
      record_status: is_level_2 ? "O" : "C",
    });

  const { data: districts, refetch: refetchDistricts } = useDistricts({
    ...districtParams,
    record_status: is_level_2 ? "O" : "C",
  });

  const { data: wards, refetch: refetchWards } = useWards({
    ...wardParams,
    record_status: is_level_2 ? "O" : "C",
  });

  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces, is_level_2]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts, is_level_2]);

  useEffect(() => {
    if (wardParams?.type === 3 && !is_level_2) refetchWards();
  }, [wardParams, refetchWards, is_level_2]);

  const [provinceMenu, setProvinceMenu] = useState(undefined);
  useEffect(() => {
    if (receiver_province_code) {
      const provincesValue =
        receiver_province_code && Object.keys(receiver_province_code);
      setProvinceMenu(
        provincesValue.map(item => {
          return { label: receiver_province_code?.[item], value: item };
        })
      );
    }
  }, [receiver_province_code]);

  useEffect(() => {
    if (transportParams.run) {
      refetchTransports();
    }
  }, [transportParams]);

  useEffect(() => {
    if (location) {
      setTransportParams(prev => ({
        ...prev,
        run: true,
        params: {
          ...prev.params,
          "filter[hub_id]": location.hub_id,
        },
      }));
    }
  }, [location]);

  return (
    <Form className="p-4 customer-location-form">
      {/* {isTypeReturn() && !location && ( */}

      {isTypeReturn() && (
        <Row className="mb-3">
          <Col md={6}>
            <FormGroup>
              <Label
                className="d-flex align-items-center gap-1"
                style={{ cursor: "pointer" }}
                htmlFor="is_level_2"
                onClick={() => handleChangeIsLevel2(!is_level_2)}
              >
                <Switch checked={is_level_2} onChange={handleChangeIsLevel2} />
                Địa chỉ 2 cấp
              </Label>
            </FormGroup>
          </Col>
        </Row>
      )}
      <Row xs={1} md={2}>
        {isTypeReturn() ? (
          <>
            <Col>
              <FormHubSelect
                isRequired
                mainForm={mainForm}
                fieldName="hub_id"
                t={tCustomer}
                hubIdDefault={location?.hub_id}
                title={tCustomer("form.hub")}
                onChange={onChangeHub}
                addressLevel={is_level_2 ? 2 : 3}
                key={`hub-select-${is_level_2}-${location?.id || "create"}`}
              />
            </Col>
            <Col>
              <FormGroup>
                <Label htmlFor="transport">
                  {tCustomer("form.transport")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="transport_id"
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: tCustomer("form.transport"),
                      })}
                      options={optionTransport}
                      classNamePrefix="select2-selection"
                      isDisabled={isDisableTransport}
                    />
                  )}
                />
                {errors.transport_id && (
                  <MessageFormValidate
                    error={errors.transport_id?.["message"]}
                  />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label htmlFor="code">Code</Label>
                <input
                  name="code"
                  type="text"
                  disabled={true}
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    "code"
                  )}`}
                  placeholder={""}
                  {...register("code")}
                />
                {errors.code && (
                  <MessageFormValidate error={errors.code.message} />
                )}
              </FormGroup>
            </Col>
          </>
        ) : (
          <></>
        )}
        <Col>
          <FormGroup>
            <Label htmlFor="receiver_province_code">
              {t("form.receiver_province_code")}{" "}
              <span className="text-danger">*</span>
            </Label>
            <Controller
              control={control}
              name="province_code"
              render={({ field }) => (
                <ProvinceSelect
                  {...field}
                  isLevel2={is_level_2}
                  isSearchable
                  onChange={e => {
                    setValue("province_code", e);
                    setValue("district_code", null);
                    setValue("ward_code", null);
                  }}
                />
              )}
            />
            {errors.province_code && (
              <MessageFormValidate error={errors.province_code?.["message"]} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="receiver_district_code">
              {is_level_2 ? "Phường xã" : "Quận huyện"}{" "}
              <span className="text-danger">*</span>
            </Label>
            <Controller
              control={control}
              name="district_code"
              render={({ field }) => (
                <DistrictSelect
                  {...field}
                  isLevel2={is_level_2}
                  placeholder={t("placeholder.select", {
                    title: is_level_2 ? "Phường xã" : "Quận huyện",
                  })}
                  provinceId={watch("province_code")?.value}
                  isSearchable
                  isDisabled={!watch("province_code")}
                  onChange={e => {
                    setValue("district_code", e);
                    setValue("ward_code", null);
                  }}
                />
              )}
            />
            {errors.district_code && (
              <MessageFormValidate error={errors.district_code?.["message"]} />
            )}
          </FormGroup>
        </Col>
        {!is_level_2 && (
          <Col>
            <FormGroup>
              <Label htmlFor="receiver_ward_code">
                {t("form.receiver_ward_code")}{" "}
                <span className="text-danger">*</span>
              </Label>
              <Controller
                control={control}
                name="ward_code"
                render={({ field }) => (
                  <WardSelect
                    {...field}
                    isLevel2={is_level_2}
                    districtId={watch("district_code")?.value}
                    isSearchable
                    isDisabled={!watch("district_code")}
                  />
                )}
              />
              {errors.ward_code && (
                <MessageFormValidate
                  error={String(errors.ward_code?.["message"])}
                />
              )}
            </FormGroup>
          </Col>
        )}
        <Col>
          <FormGroup>
            <Label htmlFor="address">
              {t("form.receiver_address")}{" "}
              <span className="text-danger">*</span>
            </Label>
            <input
              name="address"
              type="text"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "address"
              )}`}
              placeholder={t("placeholder.enter", {
                title: t("form.receiver_address"),
              })}
              {...register("address")}
            />
            {errors.address && (
              <MessageFormValidate error={errors.address.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="receiver_contact_name">
              {t("form.receiver_contact_name")}
            </Label>
            <input
              type="text"
              id="receiver_contact_name"
              placeholder={t("placeholder.enter", {
                title: t("form.receiver_contact_name"),
              })}
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "contact_name"
              )}`}
              {...register("contact_name")}
            />
            {errors.contact_name && (
              <MessageFormValidate error={errors.contact_name.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="receiver_contact_phone">
              {t("form.receiver_contact_phone")}
            </Label>
            <input
              type="number"
              id="receiver_contact_phone"
              placeholder={t("placeholder.enter", {
                title: t("form.receiver_contact_phone"),
              })}
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "contact_phone"
              )}`}
              {...register("contact_phone")}
            />
            {errors.contact_phone && (
              <MessageFormValidate error={errors.contact_phone.message} />
            )}
          </FormGroup>
        </Col>
        {isTypeReturn() && (
          <React.Fragment>
            <Col>
              <FormGroup>
                <Label htmlFor="mapping_code">{t("form.mapping_code")}</Label>
                <input
                  type="text"
                  id="mapping_code"
                  placeholder={t("placeholder.enter", {
                    title: t("form.mapping_code"),
                  })}
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    "mapping_code"
                  )}`}
                  {...register("mapping_code")}
                />
                {errors.mapping_code && (
                  <MessageFormValidate error={errors.mapping_code.message} />
                )}
              </FormGroup>
            </Col>
            <Col className="mt-4">
              <FormGroup>
                <Label check className="d-flex gap-1">
                  <input
                    name="is_default"
                    type="checkbox"
                    className="mt-0"
                    {...register("is_default")}
                    onChange={() => {
                      const value = !getValues("is_default");
                      setValue("is_default", value);
                    }}
                  />
                  <div>{t("form.is_default")}</div>
                </Label>
              </FormGroup>
            </Col>
          </React.Fragment>
        )}
      </Row>
      {type !== CustomerLocationType.RECEIVE && (
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label htmlFor="group_code">{t("form.group_code")}</Label>
              <Controller
                control={control}
                name="group_code"
                render={({ field }) => (
                  <GroupCodeSelect
                    defaultSelectAll={location ? false : true}
                    setValue={setValue}
                    {...field}
                    // onChange={e => {
                    //   setValue("group_code", e);
                    // }}
                  />
                )}
              />
              {errors.group_code && (
                <MessageFormValidate error={errors.group_code?.["message"]} />
              )}
            </FormGroup>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <Button
            color="danger"
            outline
            className="border-0"
            size="xs"
            onClick={props?.handleCancel}
          >
            {t("button.cancel")}
          </Button>
        </Col>
        <Col className="text-end">
          <Button
            size="xs"
            color="primary"
            style={{ backgroundColor: "#3C64B1" }}
            onClick={handleSubmitForm}
            disabled={isLoadingUpdateLocation || isLoadingCreateLocation}
          >
            {location ? t("button.update") : t("button.add")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default CustomerLocationForm;
